<c-container class="mt-5">
  <app-choose-your-game (gameChosenEvent)="onGameChange($event)"
                        [message]="'Choose a game to manage notifications'"></app-choose-your-game>

  @if (chosenGame) {
    @if (uiState === uiStateEnumForTemplate.ShowLoading) {
      <div class="text-center mt-4">
        <mat-spinner></mat-spinner>
      </div>
    } @else if (uiState === uiStateEnumForTemplate.ShowData) {
      <app-email-players-button class="mt-4 d-block" [gameId]="chosenGame.Id"></app-email-players-button>
      <div class="text-end mt-4">
        <button mat-raised-button
                [routerLink]="['/', chosenGame.Id, 'create-broadcast-notification']"
                data-testid="add-new-notification-button"
                *hasPermission="permissionTypes.ModifyBroadcastNotifications"
                class="primary-button">
          Add New Notification
        </button>
      </div>

      <app-broadcast-notifications-table [notifications]="broadcastNotifications"></app-broadcast-notifications-table>
    }
  }
</c-container>
